export default __webpack_public_path__ + "static/media/pattern.3481d4bb.png";